import { render, staticRenderFns } from "./PredefinedCommentsTable.vue?vue&type=template&id=5d837a3c&"
import script from "./PredefinedCommentsTable.vue?vue&type=script&lang=js&"
export * from "./PredefinedCommentsTable.vue?vue&type=script&lang=js&"
import style0 from "./PredefinedCommentsTable.vue?vue&type=style&index=0&id=5d837a3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports